import clsx from 'clsx';
import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FileMessage } from '@/shared/components/atoms/MessageItem/FileMessage/indx';
import { IMessageItemProps } from '@/shared/components/atoms/MessageItem/MessageItem';

const MessageItem: React.FC<IMessageItemProps> = ({
  senderName,
  text,
  timestamp,
  type,
  file,
}) => {
  const { t } = useTranslation('common');
  return (
    <div
      className={clsx(
        'flex w-full',
        type === 'sender' ? 'justify-end' : 'justify-start'
      )}
    >
      <div className='w-fit max-w-[75%]'>
        <div className='flex w-full items-center justify-between gap-1'>
          <span className='flex items-center gap-1 text-14 font-medium text-primary-400'>
            {senderName}
            {type === 'receiver' ? (
              <>
                <span>-</span>
                <span className='text-12'>{t('beta')}</span>
              </>
            ) : (
              ''
            )}
          </span>
          <span className='text-12 text-surface-10'>
            {format(timestamp, 'eeee p')}
          </span>
        </div>
        <div className='flex flex-col justify-end gap-2'>
          {text && (
            <span
              className={clsx(
                'rounded-xl px-14 py-9 text-base',
                type === 'sender'
                  ? 'text-white ltr:rounded-tr-[0px] rtl:rounded-tl-[0px]'
                  : 'bg-background-neutral-100 text-text-default ltr:rounded-tl-[0px] rtl:rounded-tr-[0px]'
              )}
              style={
                type === 'sender'
                  ? {
                      background:
                        'linear-gradient(135deg, #3432C7 0%, #B632C7 100%)',
                    }
                  : {}
              }
            >
              {text}
            </span>
          )}
          {file && <FileMessage file={file} />}
        </div>
      </div>
    </div>
  );
};

export { MessageItem };
